import React from "react";

const CourseCard = ({ image, title }) => {
  return (
    <div
      className="bg-white py-4 rounded"
      role="button"
      style={{ boxShadow: "box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);" }}
    >
      <img src={image} alt="" style={{ width: "144px", height: "160px" }} />
      <div>
        <p className="fs-4 fw-medium mt-3">{title}</p>
      </div>
    </div>
  );
};

export default CourseCard;
